import React, { useState } from 'react';
import './SearchBar.scss';
import { BsSearch } from 'react-icons/bs';
import { MdClose } from 'react-icons/md';

type Props = {
  term?: string;
  onChange?: (arg: string) => void;
  onEnter?: () => void;
};
const SearchBar = (props: Props) => {
  const [value, setValue] = useState(props.term || '');
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    props.onChange?.(e.target.value);
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      props.onEnter?.();
    }
  };

  const onClear = () => {
    setValue('');
  };

  return (
    <div className="search-bar">
      <div className="search-bar__left">
        <BsSearch className="search-bar__left__icon" />
        <input
            onChange={onChange}
            onKeyDown={onKeyDown}
            value={value}
          type="text"
          className="search-bar__input"
          placeholder="Search products"
        />
      </div>
      <div className="search-bar__right">
        <MdClose onClick={onClear} style={{ color: '#D3D3D3', fontSize: '22px' }} className="search-bar__right__icon" />
      </div>
    </div>
  );
};

export default SearchBar;
